// extracted by mini-css-extract-plugin
export var connectionButton = "_b1-1";
export var rightPanel = "_b1-3";
export var stepDescription = "_b1-2";
export var stepIcon = "_b1-0";